import MoveUpAnimation from '../components/MoveUpAnimation'
import PageBase from '../components/PageBase'
import { useAppT } from '../localization/config'

export default function WorkshopsPage() {
  const t = useAppT()

  return (
    <PageBase title={t.workshops_title} scroolToTop>
      <MoveUpAnimation>
        <div className="rounded-xl shadow-2xl border border-primary p-6">
          <h2>{t.workshops_1_title}</h2>

          <p className="mb-3">{t.workshops_1_text_1}</p>
          <p className="mb-3">{t.workshops_1_text_2}</p>

          <p className="mb-3">{t.workshops_1_ul_title}</p>
          <ul className="list-[circle] space-y-3">
            <li>{t.workshops_1_ul_item_1}</li>
            <li>{t.workshops_1_ul_item_2}</li>
          </ul>
        </div>
      </MoveUpAnimation>
    </PageBase>
  )
}
